import { createSlice } from "@reduxjs/toolkit";
import { editDishesAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editDishesSlice = createSlice({
  name: "editDishes",
  initialState: data,
  reducers: {
   editDishesSlice(state) {
      state.isLoading = true;
    },
   editDishesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editDishesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editDishesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const editDishesHandler: any = (id:any, data:any) => async (dispatch: any) => {
  try {
    dispatch(editDishesAction.editDishesSlice());
    const response: any = await editDishesAPI(id, data);
    
    dispatch(editDishesAction.editDishesSliceSuccess(response));
  } catch (e: any) {
    dispatch(editDishesAction.editDishesSliceFailure(e?.response?.data));
  }
};

export default editDishesSlice.reducer;
export const editDishesAction = editDishesSlice.actions;
